"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../actions/");
const reducers_1 = require("../../../reducers");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const FormSection_1 = require("../../utils/FormSection");
const Row_1 = require("../components/Row");
const TimezonePicker_1 = require("./TimezonePicker");
const DatePickerContainer_1 = require("../components/DatePickerContainer");
const TimePickerContainer_1 = require("./TimePickerContainer");
const luxon_1 = require("luxon");
const moment = require("moment-timezone");
const DateAndTime = ({ device, scheduledTrigger, updateTrigger, }) => {
    const { dateTime } = scheduledTrigger;
    let timeZone = undefined;
    if (dateTime) {
        timeZone = dateTime.timeZone;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(FormSection_1.default, { device: device, style: { marginTop: 24 } },
            React.createElement(src_1.Text, { text: "Date and Time", size: "h1" })),
        React.createElement(FormSection_1.default, { device: device },
            React.createElement(src_1.Text, { text: "When should this notification be delivered?", size: "h2" }),
            React.createElement(Row_1.default, { onClick: () => updateTrigger({ dateTime: null }) },
                React.createElement(src_1.Text, { text: "As soon as it's published", size: "large" }),
                React.createElement(src_1.RadioButton, { selected: !dateTime, style: {
                        outerStyle: { height: 18, width: 18 },
                    } })),
            React.createElement(Row_1.default, { onClick: () => {
                    const d = luxon_1.DateTime.local();
                    const date = d.toISODate();
                    const t = d.toObject();
                    const time = t.hour * 3600 + t.minute * 60 + t.second;
                    updateTrigger({
                        dateTime: {
                            date,
                            time,
                            timeZone: moment.tz.guess(),
                        },
                    });
                } },
                React.createElement(src_1.Text, { text: "A scheduled date and time", size: "large" }),
                React.createElement(src_1.RadioButton, { selected: !!dateTime, style: {
                        outerStyle: { height: 18, width: 18 },
                    } }))),
        !!dateTime && (React.createElement(FormSection_1.default, { device: device },
            React.createElement(src_1.Text, { text: "Scheduled the delivery", size: "h2" }),
            React.createElement(DatePickerContainer_1.default, { date: dateTime ? dateTime.date : null, device: device, field: "scheduledDate", label: "Date", update: (date) => updateTrigger({
                    dateTime: {
                        date,
                        time: dateTime && dateTime.time ? dateTime.time : 0,
                        timeZone,
                    },
                }) }),
            React.createElement(TimePickerContainer_1.default, { device: device }),
            React.createElement(Row_1.default, { onClick: () => updateTrigger({
                    dateTime: Object.assign(Object.assign({}, dateTime), { timeZone: timeZone ? undefined : 'America/Toronto' }),
                }) },
                React.createElement(src_1.Text, { text: "Use local device time zone?", size: "large" }),
                React.createElement(src_1.Switch, { on: !timeZone, onClick: () => updateTrigger({
                        dateTime: Object.assign(Object.assign({}, dateTime), { timeZone: timeZone ? undefined : 'America/Toronto' }),
                    }) })),
            !!timeZone && React.createElement(TimezonePicker_1.default, { device: device })))));
};
const mapStateToProps = (state) => ({
    scheduledTrigger: reducers_1.getEditableCampaignScheduledCampaignTrigger(state),
});
const mapDispatchToProps = (dispatch) => ({
    updateTrigger: (t) => dispatch(actions_1.updateScheduledCampaignTrigger(t)),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(DateAndTime);
